import { Routes, Route } from 'react-router-dom'; // Ohne BrowserRouter importieren
import Home from './pages/Home';
import { AboutMe } from './pages/AboutMe';
import News from './pages/News';
import SettingsMenu from './pages/SettingsMenu'; // Achte auf den Standard-Import
import './App.css';
import { Navbar } from './components/Navbar';
import Login from './Login/Login';
import Registrieren from './Login/Registrieren';
import Admin from './Admin/Admin';
import { useState, useEffect } from 'react';
import { auth } from '../src/Admin/Api';
import { useNavigate } from 'react-router-dom';

function App() {
    const [role, setRole] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const roleFromStorage = localStorage.getItem("role");
        setRole(roleFromStorage)
        auth().then(isAuth => {
            if (!isAuth) {
                handleLogout()
            }
        });
    }, [navigate]);

    const handleLogout = () => {
        // Alle Daten aus localStorage entfernen und den Login-Status zurücksetzen
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('role');
        localStorage.removeItem('token');
        localStorage.removeItem('userId'); // Optional, falls du die User-ID im LocalStorage speicherst
    };

    return (
        <div className="App">
            <Routes>
                {/* Protected Routes */}
                <>
                    <Route path="/" element={<><Navbar /><Home /></>} />
                    <Route path="/aboutMe" element={<><Navbar /><AboutMe /></>} />
                    <Route path="/news" element={<><Navbar /><News /></>} />
                    <Route path="/settingsMenu" element={<><Navbar /><SettingsMenu /></>} />
                    {role === "ADMIN" && (
                        <Route path="/admin" element={<><Navbar /><Admin /></>} />
                    )}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Registrieren />} />
                </>
            </Routes>
        </div>
    );
}

export default App;
